import React from "react";
import { Modal as RNModal, View, Pressable, StyleSheet } from "react-native";

type Props = {
  isVisible: boolean;
  children?: React.ReactNode;
  onBackdropPress?: () => void;
  style?: any; // opcional: estilo do *container* que segura os children (não altera posicionamento)
};

export const Modal = ({ isVisible, children, onBackdropPress, style, ...props }: Props) => {
  return (
    <RNModal
      visible={isVisible}
      transparent
      animationType="fade"
      onRequestClose={onBackdropPress} // Android back
      {...props}
    >
      {/* camada raiz ocupando a tela inteira */}
      <View style={StyleSheet.absoluteFill}>
        {/* backdrop clicável atrás do conteúdo */}
        <Pressable
          style={[StyleSheet.absoluteFill, { backgroundColor: "rgba(0,0,0,0.5)" }]}
          onPress={onBackdropPress}
        />

        {/* camada de conteúdo sem interferir no layout
            - absoluteFill para ocupar a tela (como o RNModal faz)
            - pointerEvents="box-none" para que cliques em áreas vazias
              atravessem e atinjam o backdrop */}
        <View style={[StyleSheet.absoluteFill, style]} pointerEvents="box-none">
          {children}
        </View>
      </View>
    </RNModal>
  );
};

export default Modal;
